import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    id="study-manager"
    width="75.558"
    height="73.316"
    viewBox="0 0 75.558 73.316"
  >
    <path
      id="Caminho_62"
      data-name="Caminho 62"
      d="M75.559,1.643A1.592,1.592,0,0,0,74.008,0H1.551A1.592,1.592,0,0,0,0,1.643v58.62a1.5,1.5,0,0,0,1.55,1.532H26.064l-2.3,8.324H19.606a1.6,1.6,0,0,0,0,3.2H55.954a1.6,1.6,0,0,0,0-3.2H51.8l-2.3-8.324H74.008a1.5,1.5,0,0,0,1.551-1.532ZM3.2,3.205H72.357V47.387H3.2ZM48.475,70.118H27.085l2.3-8.324H46.171ZM72.357,58.593H3.2v-8H72.357Zm0,0"
      transform="translate(-0.001 -0.004)"
      fill="#757e8d"
    />
    <path
      id="Caminho_63"
      data-name="Caminho 63"
      d="M114.751,83.749H108.37a1.6,1.6,0,0,0-1.257.61L102.587,90.1,97.705,77.929a1.6,1.6,0,0,0-1.454-1h-.033a1.6,1.6,0,0,0-1.461.947L86.737,95.806,78.854,72.589a1.6,1.6,0,0,0-2.9-.285l-6.6,11.445H61.6a1.6,1.6,0,1,0,0,3.2h8.674a1.6,1.6,0,0,0,1.387-.8l5.294-9.183L85.017,100.7a1.6,1.6,0,0,0,1.441,1.084l.074,0a1.6,1.6,0,0,0,1.461-.947l8.145-18.212,4.505,11.236a1.6,1.6,0,0,0,2.743.4l5.758-7.305h5.6a1.6,1.6,0,1,0,0-3.2Zm0,0"
      transform="translate(-50.399 -55.876)"
      fill="#757e8d"
    />
  </svg>,
  'StudyManagerIcon',
);
